<template>
  <div>
    <AICrudTable />
  </div>
</template>

<script>
export default {
  name: 'AIReport',
  components: {
    AICrudTable: () => import('../../components/table/AICrudTable.vue')
  }
};
</script>
